import { defineComponent as _defineComponent } from 'vue';
import {} from "./labels";
export default /*#__PURE__*/ _defineComponent({
    __name: 'LabelSelector',
    props: {
        hasLabels: { type: Boolean },
        labels: null,
        value: { default: undefined },
        labelTitle: null
    },
    emits: ["input"],
    setup(__props, { emit }) {
        const props = __props;
        function update(index) {
            const label = props.labels[index] || undefined;
            emit("input", label);
        }
        return { __sfc: true, props, emit, update };
    }
});
